// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"22c89b8e","324":"c4edc9ca","636":"5fc3229b","700":"e9a6d2b7","903":"5aeef2df"}[chunkId] + ".chunk.css";
};